import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './routes/Login'
import Dashboard from './routes/Dashboard'
import Sources from './routes/Sources'
import Items from './routes/Items'
import Topics from './routes/Topics'
import Analysis from './routes/Analysis'
import Jobs from './routes/Jobs'
import Consumers from './routes/Consumers'
import Settings from './routes/Settings'
import Layout from './components/Layout'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="/items" element={<Items />} />
        <Route path="/topics" element={<Topics />} />
        <Route path="/analysis" element={<Analysis />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/consumers" element={<Consumers />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
